import React, { Dispatch, SetStateAction } from 'react'

import { Box, Icon, Spinner, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import WistiaPlayer from 'modules/onboarding/components/WistiaPlayer'
import { EventPayload } from 'modules/onboarding/hooks/useExternalLinks'

import useFetchVideos, {
  Media,
} from 'modules/onboarding/components/HelpWidget/WidgetSidepanel/hooks/useFetchVideos'

const secondsToDuration = (seconds: number) => {
  const min = Math.floor(seconds / 60)
  const sec = Math.floor(seconds % 60)
  return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
}

type ThumbnailProps = {
  id: string
  title: string
  duration: string
  eventPayload: EventPayload
}

const Thumbnail = ({ id, title, duration, eventPayload }: ThumbnailProps) => {
  return (
    <Box flexDirection="row" gap="s16">
      <Box
        style={{ width: '126px' }}
        onClick={() =>
          track(trackingEvents.onboarding.openedVideoTutorial, {
            ...eventPayload,
            video_title: title,
          })
        }
      >
        <WistiaPlayer videoId={id} isResponsive={false} />
      </Box>
      <Box gap="s4" cursor="default">
        <Text.Normal size="200" color="grey800" weight="medium" lineClamp={2}>
          {title}
        </Text.Normal>
        <Text.Normal size="200" color="grey700">
          {duration}
        </Text.Normal>
      </Box>
    </Box>
  )
}

type TutorialsProps = {
  eventPayload: EventPayload
  setIsTutorialsSectionOpen: Dispatch<SetStateAction<boolean>>
}

const Tutorials = ({ eventPayload, setIsTutorialsSectionOpen }: TutorialsProps) => {
  const { data, isLoading, isError } = useFetchVideos()

  return (
    <Box>
      <Box
        flexDirection="row"
        gap="s6"
        cursor="pointer"
        onClick={() => setIsTutorialsSectionOpen(false)}
      >
        <Icon.Medium icon="arrow-left" color="viridian1200" />
        <Text.Normal color="viridian1200" weight="medium">
          {i18n.t('help_widget.sidepanel.resources.back')}
        </Text.Normal>
      </Box>
      {isLoading && (
        <Box alignItems="center" paddingTop="s48">
          <Spinner />
        </Box>
      )}
      {data.length !== 0 && (
        <Box gap="s16" paddingTop="s32">
          {data.map((video: Media) => (
            <Thumbnail
              key={video.hashed_id}
              id={video.hashed_id}
              title={video.name}
              duration={secondsToDuration(video.duration)}
              eventPayload={eventPayload}
            />
          ))}
        </Box>
      )}
      {isError && (
        <Box paddingTop="s16">
          <Text.Normal size="200" weight="medium">
            {i18n.t('help_widget.sidepanel.resources.error')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default Tutorials
